//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_RankingEvents } from "../../api";
export default {
  data() {
    return {
      statusMap: {
        0: "未开始",
        1: "进行中",
        2: "已结束",
      },
      openIndex: -1,
      points: {
        month: false,
        week: false,
        day: false,
      },
      dayRankingEvents: {},
      weekRankingEvents: {},
      monthRankingEvents: {},
    };
  },
  props: {
    chongzhiActive: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    currData() {
      if (this.chongzhiActive == 1) return this.monthRankingEvents;
      if (this.chongzhiActive == 2) return this.weekRankingEvents;
      if (this.chongzhiActive == 3) return this.dayRankingEvents;
      return {
        currEvents: [],
        otherEvents: [],
      };
    },
    preData() {
      if (!this.currData || !this.currData.otherEvents) return [];
      return this.currData.otherEvents
        .filter((item) => item.status == 0)
        .sort((a, b) => Date.parse(a.startTime) - Date.parse(b.startTime));
    },
    timeoutData() {
      if (!this.currData || !this.currData.otherEvents) return [];
      return this.currData.otherEvents
        .filter((item) => item.status == 2)
        .sort((a, b) => Date.parse(a.startTime) - Date.parse(b.startTime));
    },
  },
  watch: {
    "currData.currEvents": {
      immediate: true,
      handler(currEvents) {
        this.$emit(
          "current-events-change",
          Boolean(currEvents && currEvents.length)
        );
      },
    },
  },
  methods: {
    open(i) {
      if (this.openIndex == i) {
        this.openIndex = -1;
      } else {
        this.openIndex = i;
      }
    },
    getMaxLength(resultJson) {
      // 获取长度
      let len = 0;
      // 总战力
      if (resultJson.consumeRanking && resultJson.consumeRanking.length > len)
        len = resultJson.consumeRanking.length;
      // 充值额度
      if (resultJson.paymentRanking && resultJson.paymentRanking.length > len)
        len = resultJson.paymentRanking.length;

      // 盒战
      if (
        resultJson.caseBattleConsumeRanking &&
        resultJson.caseBattleConsumeRanking.length > len
      )
        len = resultJson.caseBattleConsumeRanking.length;
      if (
        resultJson.caseBattleCountRanking &&
        resultJson.caseBattleCountRanking.length > len
      )
        len = resultJson.caseBattleCountRanking.length;
      if (
        resultJson.caseBattleTypeRanking &&
        resultJson.caseBattleTypeRanking.length > len
      )
        len = resultJson.caseBattleTypeRanking.length;

      // 升级
      if (
        resultJson.contractConsumeRanking &&
        resultJson.contractConsumeRanking.length > len
      )
        len = resultJson.contractConsumeRanking.length;
      if (
        resultJson.contractCountRanking &&
        resultJson.contractCountRanking.length > len
      )
        len = resultJson.contractCountRanking.length;
      if (
        resultJson.contractTypeRanking &&
        resultJson.contractTypeRanking.length > len
      )
        len = resultJson.contractTypeRanking.length;

      // 开箱
      if (
        resultJson.openCaseConsumeRanking &&
        resultJson.openCaseConsumeRanking.length > len
      )
        len = resultJson.openCaseConsumeRanking.length;
      if (
        resultJson.openCaseCountRanking &&
        resultJson.openCaseCountRanking.length > len
      )
        len = resultJson.openCaseCountRanking.length;
      if (
        resultJson.openCaseTypeRanking &&
        resultJson.openCaseTypeRanking.length > len
      )
        len = resultJson.openCaseTypeRanking.length;

      return len;
    },
    getContent(list, i) {
      // 获取内容
      if (!list || !list[i]) return `<span>--</span>`;
      return `<div style="text-align:center;font-size:12px">${
        list[i].Name || list[i].name
      }<div style="margin-top:4px;font-size:14px">${
        list[i].Amount || list[i].amount
      }</div></div>`;
    },
    getContentCount(list, i) {
      // 获取内容
      if (!list || !list[i]) return `<span>--</span>`;
      return `<div style="text-align:center;font-size:12px">${
        list[i].Name || list[i].name
      }<div style="margin-top:4px;font-size:14px">${
        list[i].Count || list[i].count
      }</div></div>`;
    },
    getData() {
      api_RankingEvents().then((res) => {
        if (res?.data?.data) {
          if (res?.data?.data?.dayRankingEvents?.otherEvents) {
            res.data.data.dayRankingEvents.otherEvents.forEach((item) => {
              try {
                item.resultJson = toLowercaseKeys(JSON.parse(item.resultJson));
              } catch {}
            });
          }
          if (res?.data?.data?.weekRankingEvents?.otherEvents) {
            res.data.data.weekRankingEvents.otherEvents.forEach((item) => {
              try {
                item.resultJson = toLowercaseKeys(JSON.parse(item.resultJson));
              } catch {}
            });
          }
          if (res?.data?.data?.monthRankingEvents?.otherEvents) {
            res.data.data.monthRankingEvents.otherEvents.forEach((item) => {
              try {
                item.resultJson = toLowercaseKeys(JSON.parse(item.resultJson));
              } catch {}
            });
          }

          this.dayRankingEvents = res?.data?.data?.dayRankingEvents || {};
          this.weekRankingEvents = res?.data?.data?.weekRankingEvents || {};
          this.monthRankingEvents = res?.data?.data?.monthRankingEvents || {};

          const points = {
            month: false,
            week: false,
            day: false,
          };
          this.points = points;

          if (
            this.monthRankingEvents.otherEvents &&
            this.monthRankingEvents.otherEvents.find((item) => item.status == 0)
          ) {
            this.chongzhiActive = 1;
            points.month = true;
          }
          if (
            this.weekRankingEvents.otherEvents &&
            this.weekRankingEvents.otherEvents.find((item) => item.status == 0)
          ) {
            this.chongzhiActive = 2;
            points.week = true;
          }
          if (
            this.dayRankingEvents.otherEvents &&
            this.dayRankingEvents.otherEvents.find((item) => item.status == 0)
          ) {
            this.chongzhiActive = 3;
            points.day = true;
          }

          if (
            this.monthRankingEvents.currEvents &&
            this.monthRankingEvents.currEvents.length
          ) {
            this.chongzhiActive = 1;
            points.month = true;
          }
          if (
            this.weekRankingEvents.currEvents &&
            this.weekRankingEvents.currEvents.length
          ) {
            this.chongzhiActive = 2;
            points.week = true;
          }
          if (
            this.dayRankingEvents.currEvents &&
            this.dayRankingEvents.currEvents.length
          ) {
            this.chongzhiActive = 3;
            points.day = true;
          }
          this.points = points;
        }
      });
    },
  },
  mounted() {
    console.log("this.chongzhiActive==", this.chongzhiActive);
    setTimeout(() => {
      this.getData();
    }, 500);
  },
};

function toLowercaseKeys(obj) {
  const newObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1);
      newObj[newKey] = obj[key];
    }
  }
  return newObj;
}
